var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ReleaseDocumentNumberApplication"),
        width: _vm.$selectByLang("450px", "450px", "550px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "releaseForm",
          staticClass: "release-application-form",
          attrs: {
            model: _vm.releaseForm,
            rules: _vm.rules,
            "label-width": _vm.$selectByLang("140px", "140px", "180px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_ReleaseNumberDocument"),
                prop: "releaseType"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.releaseForm.releaseType,
                    callback: function($$v) {
                      _vm.$set(_vm.releaseForm, "releaseType", $$v)
                    },
                    expression: "releaseForm.releaseType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ReleaseNumber"),
                      value: 0
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ReleaseDocument"),
                      value: 1
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_IsPaymentReceived"),
                prop: "paymentReceived"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.releaseForm.paymentReceived,
                    callback: function($$v) {
                      _vm.$set(_vm.releaseForm, "paymentReceived", $$v)
                    },
                    expression: "releaseForm.paymentReceived"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Yes"), value: true }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_No"), value: false }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_PaymentTime2"),
                prop: "paymentTime"
              }
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.releaseForm.paymentTime,
                  callback: function($$v) {
                    _vm.$set(_vm.releaseForm, "paymentTime", $$v)
                  },
                  expression: "releaseForm.paymentTime"
                }
              })
            ],
            1
          ),
          _vm.type === "number"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ReleaseNumberQuantity"),
                    prop: "releaseQuantity"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "number", min: 1 },
                    model: {
                      value: _vm.releaseForm.releaseQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.releaseForm, "releaseQuantity", $$v)
                      },
                      expression: "releaseForm.releaseQuantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.type === "document"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_BLNo"),
                    prop: "billNo"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.releaseForm.billNo,
                      callback: function($$v) {
                        _vm.$set(_vm.releaseForm, "billNo", $$v)
                      },
                      expression: "releaseForm.billNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_RelatedAttachments"),
                prop: "attachments"
              }
            },
            [
              _c(
                "div",
                { staticClass: "upload-file-row" },
                [
                  _vm.hasReleaseUploadedFile
                    ? [
                        _c("span", { staticClass: "upload-file-name" }, [
                          _vm._v(_vm._s(_vm.getUploadedFileName()))
                        ]),
                        _c("el-button", {
                          staticClass: "upload-file-remove",
                          attrs: { type: "text", icon: "el-icon-close" },
                          on: { click: _vm.handleRemoveUpload }
                        })
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.cloudFile.visible = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Upload")) + " "
                          )
                        ]
                      )
                ],
                2
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Application_Reason"),
                prop: "applicationReason"
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 4 },
                model: {
                  value: _vm.releaseForm.applicationReason,
                  callback: function($$v) {
                    _vm.$set(_vm.releaseForm, "applicationReason", $$v)
                  },
                  expression: "releaseForm.applicationReason"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "submit" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.uploadSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }